export default __webpack_public_path__ + "static/media/5.f4d018f4.png";